"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AccountBalanceDialog = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _types = require("../../types");
var _styles = require("./styles");
var _useAccountBalanceDialog = require("./useAccountBalanceDialog");
var _jsxRuntime = require("react/jsx-runtime");
const AccountBalanceDialog = (param)=>{
    let { isBalanceDialogOpen, toggleBalanceDialog } = param;
    const { getTestIdProps } = (0, _testidGenerator.default)();
    const balanceSections = (0, _useAccountBalanceDialog.useAccountBalanceDialog)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.Dialog, {
        fullWidth: true,
        maxWidth: "390px",
        open: isBalanceDialogOpen,
        disablePortal: false,
        onClose: toggleBalanceDialog,
        ...getTestIdProps(_types.TestId.AccountBalanceDialog),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
            children: balanceSections.map((param)=>{
                let { description, title, lines } = param;
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.BalanceWrapper, {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.BalanceTitle, {
                            variant: "h6",
                            component: "div",
                            children: title
                        }),
                        lines.map((param)=>{
                            let { label, value } = param;
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.BalanceLine, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.BalanceItem, {
                                        variant: "body1",
                                        children: label
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.BalanceItem, {
                                        variant: "body1",
                                        children: value
                                    })
                                ]
                            }, "".concat(title).concat(label));
                        }),
                        description ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.BalanceDescription, {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                                fontSize: "inherit",
                                children: description
                            })
                        }) : null
                    ]
                }, title);
            })
        })
    });
};
exports.AccountBalanceDialog = AccountBalanceDialog;
